import { branding } from './config';
import { isAuthenticated, login, logout } from './auth';
import { applyBranding, clinicName, loadClinicBranding, logoUrl } from './entitlements';

export async function renderLanding(root: HTMLElement): Promise<void> {
  const line = await loadClinicBranding();
  applyBranding(line);
  const name = clinicName(line);
  const inSession = isAuthenticated();
  document.title = name;
  root.innerHTML = `
    <header class="nav flex items-center gap-4 bg-brand px-6 py-3 text-white">
      <a class="brand" href="/">
        <img src="${logoUrl(line.hasLogo)}" alt="" />
        ${escapeHtml(name)}
      </a>
      <nav>
        <a href="#servicios">Servicios</a>
        <a href="#consulta">Consulta</a>
        <a href="#nosotros">La clínica</a>
      </nav>
      <span class="spacer"></span>
      ${
        inSession
          ? `<a class="btn ghost" href="/app">Ir al consultorio</a><button class="btn ghost" type="button" id="salir">Salir</button>`
          : `<button class="btn ghost" type="button" id="entrar">Entrar</button>`
      }
    </header>
    <div class="hero-wrap">
      <section class="hero">
        <div>
          <p class="eyebrow">${escapeHtml(branding.city)} · Odontología</p>
          <h1 class="font-serif text-4xl font-semibold leading-tight text-ink">Cuidado dental con historia clínica clara y receta válida.</h1>
          <p class="lead">
            ${escapeHtml(line.tagline || branding.tagline)}.
            En ${escapeHtml(name)} el odontólogo dicta la consulta; el expediente
            y la receta salen con los datos que exige la normativa sanitaria del Ecuador.
          </p>
          <div class="cta">
            <a class="btn primary" href="/app" data-clinic>Abrir consultorio</a>
            <a class="btn ghost" href="#servicios">Ver servicios</a>
          </div>
        </div>
        <aside class="hero-card">
          <h2>En cada atención</h2>
          <ol>
            <li>Identificación del paciente y alergias.</li>
            <li>Motivo, examen y diagnóstico con CIE.</li>
            <li>Receta con nombre genérico (DCI) y registro ACESS.</li>
            <li>Copia de respaldo en la historia clínica.</li>
          </ol>
        </aside>
      </section>
    </div>
    <section id="servicios" class="section">
      <h2>Servicios</h2>
      <div class="grid">
        <article class="card">
          <p class="kicker">Consulta</p>
          <h3>Odontología general</h3>
          <p>Diagnóstico, plan de tratamiento y seguimiento con odontograma y CIE vigentes.</p>
        </article>
        <article class="card">
          <p class="kicker">Expediente</p>
          <h3>Historia clínica única</h3>
          <p>Registro sistemático alineado al formulario MSP 033 de odontología: filiación, examen, diagnóstico y prescripciones.</p>
        </article>
        <article class="card">
          <p class="kicker">Farmacia</p>
          <h3>Receta ACESS</h3>
          <p>Prescripción legible: DCI, forma farmacéutica, concentración, vía, cantidad en números y letras, dosis y vigencia.</p>
        </article>
      </div>
    </section>
    <section id="consulta" class="section">
      <h2>Cómo trabajamos</h2>
      <div class="trust">
        <div><strong>Confidencial</strong>La historia es única y reservada (Ley Orgánica de Salud, art. 7.f).</div>
        <div><strong>Trazable</strong>La receta concuerda con lo escrito en la historia (ACESS-2023-0030).</div>
        <div><strong>Quito</strong>${escapeHtml(branding.city)} · Atención ambulatoria de especialidad odontológica.</div>
      </div>
    </section>
    <section id="nosotros" class="section">
      <article class="about">
        <p class="kicker">Establecimiento</p>
        <h2>${escapeHtml(name)}</h2>
        <p>
          Consultorio odontológico. El profesional facultado registra la atención y emite
          documentos clínicos para el paciente: historia, receta e indicaciones de tratamiento.
        </p>
      </article>
    </section>
    <footer class="site-foot">
      <span>${escapeHtml(name)} · ${escapeHtml(branding.city)}</span>
      <span>Historia clínica y receta según MSP / ACESS</span>
    </footer>
  `;
  root.querySelector('#entrar')?.addEventListener('click', () => void login('/app'));
  root.querySelector('#salir')?.addEventListener('click', () => void logout());
  root.querySelectorAll<HTMLAnchorElement>('[data-clinic]').forEach((el) => {
    el.addEventListener('click', (ev) => {
      if (isAuthenticated()) return;
      ev.preventDefault();
      void login('/app');
    });
  });
}

function escapeHtml(value: string): string {
  return value.replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]!));
}
